var body = document.documentElement || document.body;
var windowWidth = window.innerWidth;
var currentOs = (function () {
    var u = navigator.userAgent;
    if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return 'ios';
    } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        return 'android';
    }
})()

function jumpToStore(os) {
    if(window.innerWidth >= 770) {
        return;
    }
    if(os == "android") {
        var url = "http://www.careagle.com/commercial/appRecommend";
    }else if(os == "ios") {
        var url = "https://itunes.apple.com/cn/app/%E8%9A%82%E8%9A%81%E5%95%86%E7%94%A8%E8%BD%A6/id1344143700?mt=8";
    }
    window.location.href = url;
    return true;
}

Vue.use(VueLazyload, {
    loading: 'http://resource.careagle.com/bg_truck_list@3x.png',
})

var app = new Vue({
    el: '#main',
    data: function () {
        return {
            windowHeight: "",
            headerVisible: false,
            footerActive: false,
            showDownloadBottom: false,
            api: {
                auctionListOfWebURL: restApi + "/auction/auctionListOfWeb",
                vehicleListOfWebURL: restApi + "/vehicle/vehicleListOfWeb",
            },

            auctionTotalCount: 10,
            auctionList: [],
            serviceList: [
                {
                    icon: imageCtx + "icon_truck@3x.png",
                    title: "一手优质车源",
                    intro: "更低价，优惠多多",
                },
                {
                    icon: imageCtx + "icon_examine@3x.png",
                    title: "远程专业检测",
                    intro: "更专业，专业检测师权威检测报告",
                },
                {
                    icon: imageCtx + "icon_for@3x.png",
                    title: "全程代办",
                    intro: "更安全，专人代办全程无忧",
                },
            ],

            vehicleList: [],
            vehicleItemWidth: "",
            downloadDialogTop: "",
            downloadDialogVisible: false,
        }
    },
    created: function () {
        this.listVehicleInfo();
        this.listAuctionInfo();
    },
    mounted: function () {
        this.scrollListener();
        this.changeIcon();
    },
    methods: {
        changeIcon: function() {
            if (windowWidth <= 770) {
                var target = document.querySelector(".header .logo");
                target.setAttribute("src", imageCtx + 'logo_antcv_red.png');
            } else {
                var commonWidth = document.querySelector(".common-width").getBoundingClientRect().width;
                var vehicleMargin = 30;
                this.vehicleItemWidth = ((commonWidth - vehicleMargin * 3) / 4).toFixed(2) + 'px';
            }
        },
        scrollListener: function() {
            var _this = this;
            var headerHeight = 80;
            var footer = document.querySelector('.footer-sec');
            var footerOffsetTop = footer.offsetTop - footer.clientHeight;
            this.windowHeight = window.innerHeight + 'px';
            _this.scrollEventHandle(body, _this, headerHeight, footerOffsetTop);

            document.addEventListener("scroll", function () {
                _this.scrollEventHandle(body, _this, headerHeight, footerOffsetTop);
            }, false)

            var bannerModule = document.querySelector(".banner-module");
            var bannerContent = document.querySelector(".banner-content");
            var topPos = (bannerModule.clientHeight - bannerContent.clientHeight) / 2;
            if (topPos) bannerContent.style.top = topPos + 'px';

            var normalImageH = 505;
            var windowH = window.innerHeight;
            if (windowH > normalImageH) {
                this.downloadDialogTop = (windowH - normalImageH) / 2 + "px";
            } else {
                this.downloadDialogTop = "0px";
            }
        },
        scrollEventHandle: function (body, _this, headerHeight, footerOffsetTop) {
            var scrollTop = window.pageYOffset || body.scrollTop;
            if (scrollTop > headerHeight && _this.headerVisible) {
                _this.headerVisible = false;
            } else if (scrollTop <= headerHeight && !_this.headerVisible) {
                _this.headerVisible = true;
            }
            if (scrollTop >= footerOffsetTop && !_this.footerActive) {
                _this.footerActive = true;
            }
        },
        computeAuctionClass: function(item) {
            if (this.auctionPreview(item)) {
                return 'isPreview';
            } else if (this.auctionDisposal(item)) {
                return 'isDisposing';
            } else if (this.auctionEnd(item)) {
                return 'isEnd'
            }
        },
        listAuctionInfo: function () {
            var _this = this;
            $.ajax({
                url: _this.api.auctionListOfWebURL,
                success: function (res) {
                    if (res.code == 200) {
                        _this.auctionList = res.data.list;
                    } else {
                        console.log(res.message);
                    }
                }
            })
        },
        listVehicleInfo: function () {
            var _this = this;
            $.ajax({
                url: _this.api.vehicleListOfWebURL,
                success: function (res) {
                    if (res.code == 200) {
                        _this.vehicleList = res.data.vehicles;
                    } else {
                        console.log(res.message);
                    }
                }
            })
        },
        formatLocation: function (vehicle) {
            var provinceName = vehicle.provinceName || '';
            var cityName = vehicle.cityName || '';
            return provinceName + cityName;
        },
        // 处置预展中
        auctionPreview: function (auction) {
            return auction.auctionStatusEnum && auction.auctionStatusEnum.key == 'PREVIEW';
        },
        // 处置中
        auctionDisposal: function (auction) {
            return auction.auctionStatusEnum && auction.auctionStatusEnum.key == 'AUCTIONING';
        },
        // 处置已结束
        auctionEnd: function (auction) {
            var key = auction.auctionStatusEnum && auction.auctionStatusEnum.key;
            var bool = false;
            if (key == 'IN_THE_TRANSACTION' || key == 'DEAL') {
                bool = true;
            }
            return bool;
        },
        showDownloadDialog: function () {
            if (!jumpToStore(currentOs)) this.downloadDialogVisible = true;
        },
        // 关闭下载栏目
        closeDownloadDialog: function () {
            this.downloadDialogVisible = false;
        },
    },
    filters: {
        filterToDecimal: function(val, key) {
            var temp = Number(val);
            if (val && !isNaN(temp) && key == 'PREVIEW') {
                return temp.toFixed(2);
            } else if(key == 'AUCTIONING' || key == 'IN_THE_TRANSACTION' || key == 'DEAL') {
                return '**.**';
            } else {
                return "0.00";
            }
        },
        formatTime: function (begin, end) {
            var today = new Date().format("yyyyMMdd");
            begin = begin.replace(/\-/g, "/");
            end = end.replace(/\-/g, "/");
            var temp = new Date(begin).format("yyyyMMdd");
            var beginStamp = new Date(begin).getTime();
            var endStamp = new Date(end).getTime();
            var nowStamp = Date.now();
            if (today - temp == -1) {
                return "明天" + new Date(begin).format("hh:mm");
            } else if (today == temp) {
                if (nowStamp <= beginStamp) {
                    return "今天" + new Date(begin).format("hh:mm") + "开竞";
                } else {
                    if (nowStamp <= endStamp) {
                        var seconds = parseInt((endStamp - nowStamp) / 1000);
                        var d = parseInt(seconds / (3600 * 24)),
                            h = parseInt((seconds % (3600 * 24)) / 3600),
                            m = parseInt(seconds % 3600 / 60),
                            str = '';
                        h = h < 10 ? '0' + h : h;
                        m = m < 10 ? '0' + m : m;
                        if (d) str += d + '天';
                        if (h) str += h + '小时';
                        if (m) str += m + "分钟";
                        return "距离结束只剩" + str;
                    } else {
                        return new Date(end).format('yyyy-MM-dd hh:mm:ss') + '结束';
                    }
                }
            } else if (today > temp) {
                return new Date(end).format('yyyy-MM-dd hh:mm:ss') + '结束';
            } else {
                return new Date(begin).format("yyyy-MM-dd hh:mm") + "开竞";
            }
        },
        regDateFilter: function (date) {
            if (date) {
                return date.split('-')[0] + '年';
            }
        },
        mileageFilter: function (mileage) {
            if (mileage || mileage === 0) {
                return (mileage / 10000).toFixed(2) + '万公里';
            } else {
                return '';
            }
        },
        statusFilter: function (key) {
            if (key == 'PREVIEW') {
                return '预展中';
            } else if (key == 'AUCTIONING') {
                return '处置中';
            } else if (key == 'IN_THE_TRANSACTION' || key == 'DEAL') {
                return '已结束';
            }
        },
        priceNameFilter: function (key) {
            if (key == 'PREVIEW') {
                return '起始价';
            } else if (key == 'AUCTIONING') {
                return '当前价';
            } else if (key == 'IN_THE_TRANSACTION' || key == 'DEAL') {
                return '成交价';
            }
        },
    }
})